// extracted by mini-css-extract-plugin
export default {"container":"Sy-z","vocBtn":"Ty-z","disabled":"Uy-z"};